import {
  ADD_SELLER_SUCCESS,
  CLEAR_ERRORS_STEP_TWO,
  CLEAR_FORM_STEP_TWO,
  DELETE_FILE,
  DELETE_FILE_ERROR,
  DELETE_FILE_SUCCESS,
  FRAGMENTATION_ALERT,
  FRAGMENTATION_ALERT_ERROR,
  FRAGMENTATION_ALERT_SUCCESS,
  GET_ATTACHED_FILES,
  GET_ATTACHED_FILES_SUCCESS,
  GET_ATTACHED_FILES_ERROR,
  GET_DOWNLOAD_FILE,
  GET_DOWNLOAD_FILE_ERROR,
  GET_DOWNLOAD_FILE_SUCCESS,
  GET_QUOTE_NOTIFICATIONS_SUCCESS,
  GET_REGIONS,
  GET_REGIONS_SUCCESS,
  GET_REGIONS_ERROR,
  GET_UNITS_MEASURE,
  GET_UNITS_MEASURE_ERROR,
  GET_UNITS_MEASURE_SUCCESS,
  HIDE_GUEST_FORM_SUCCESS,
  COMPANY_SIZE_FILTER_SUCCESS,
  REGION_NOTIFICATION_SUCCESS,
  REMOVE_SELLER_SUCCESS,
  SHOW_GUEST_FORM_SUCCESS,
  SAVE_FINES_PENALTIES_SUCCESS,
  SAVE_ROUGH_COPY,
  SAVE_ROUGH_COPY_SUCCESS,
  SAVE_ROUGH_COPY_ERROR,
  UPLOAD_FILE,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_ERROR,
  CLOSE_MORE_INFO_DIALOG,
  OPEN_MORE_INFO_DIALOG,
  SET_ENVIRONMENTAL_VALUE,
  SET_SOCIAL_ECONOMIC_VALUE
} from './QuoteStepTwo.actions'

const quoteStepTwoState = {
  attachedFiles: [],
  companySizeFilter: 0,
  error: false,
  errorAF: false,
  errors: [],
  filterRegionCode: -1,
  filterRegionNotification: 0,
  finesPenalties: false,
  fragmentationAlert: false,
  initData: {
    unitsMeasure: [],
    regions: []
  },
  loading: false,
  loadingAF: false,
  sellersAdded: [],
  showForm: true,
  isEnvironmental: '',
  isSocialEconomic: '',
  showMoreInfoDialog: false
}

/**
 * The QuoteStepTwo's reducer.
 */
const quoteStepTwoReducer = (state = quoteStepTwoState, { payload, type }) => {
  switch (type) {
    case HIDE_GUEST_FORM_SUCCESS: {
      return { ...state, showForm: false }
    }
    case SHOW_GUEST_FORM_SUCCESS: {
      return { ...state, showForm: true }
    }
    case FRAGMENTATION_ALERT: {
      return { ...state, loading: true, error: false }
    }
    case FRAGMENTATION_ALERT_ERROR: {
      return { ...state, loading: false, error: true }
    }
    case FRAGMENTATION_ALERT_SUCCESS: {
      return { ...state, loading: false, fragmentationAlert: payload.fragmentationAlert }
    }
    case GET_REGIONS:
    case GET_UNITS_MEASURE:
    case SAVE_ROUGH_COPY: {
      return { ...state, loading: true }
    }
    case GET_REGIONS_ERROR:
    case GET_UNITS_MEASURE_ERROR: {
      return { ...state, loading: false }
    }
    case GET_UNITS_MEASURE_SUCCESS: {
      return {
        ...state,
        initData: {
          ...state.initData,
          unitsMeasure: payload.unitsMeasure
        },
        loading: false
      }
    }
    case GET_REGIONS_SUCCESS: {
      return {
        ...state,
        initData: {
          ...state.initData,
          regions: payload.regions
        },
        loading: false
      }
    }
    case SAVE_ROUGH_COPY_SUCCESS: {
      return {
        ...state,
        loading: false,
        errors: []
      }
    }
    case SAVE_ROUGH_COPY_ERROR: {
      return {
        ...state,
        loading: false,
        errors: payload.error
      }
    }
    case DELETE_FILE:
    case GET_ATTACHED_FILES:
    case GET_DOWNLOAD_FILE: {
      return { ...state, loadingAF: true }
    }
    case UPLOAD_FILE: {
      return {
        ...state,
        loadingAF: true,
        errorAF: false
      }
    }
    case UPLOAD_FILE_ERROR: {
      return {
        ...state,
        loadingAF: false,
        errorAF: true
      }
    }
    case UPLOAD_FILE_SUCCESS: {
      return {
        ...state,
        loadingAF: false,
        errorAF: false
      }
    }
    case DELETE_FILE_ERROR:
    case GET_ATTACHED_FILES_ERROR:
    case GET_DOWNLOAD_FILE_ERROR: {
      return {
        ...state,
        loadingAF: false,
        error: true
      }
    }
    case GET_ATTACHED_FILES_SUCCESS: {
      return {
        ...state,
        attachedFiles: payload.attachedFiles,
        loadingAF: false,
        error: false
      }
    }
    case DELETE_FILE_SUCCESS:
    case GET_DOWNLOAD_FILE_SUCCESS: {
      return {
        ...state,
        loadingAF: false,
        error: false
      }
    }
    case CLEAR_FORM_STEP_TWO: {
      return {
        ...quoteStepTwoState,
        initData: {
          ...quoteStepTwoState.initData
        }
      }
    }
    case CLEAR_ERRORS_STEP_TWO: {
      return { ...state, errors: [] }
    }
    case SAVE_FINES_PENALTIES_SUCCESS: {
      return { ...state, finesPenalties: payload.finesPenaltiesValue }
    }
    case GET_QUOTE_NOTIFICATIONS_SUCCESS: {
      return {
        ...state,
        companySizeFilter: payload.companySizeFilter,
        filterRegionCode: payload.filterRegionCode,
        filterRegionNotification: payload.filterRegionNotification,
        sellersAdded: payload.sellersAdded
      }
    }
    case COMPANY_SIZE_FILTER_SUCCESS: {
      return { ...state, companySizeFilter: payload.companySizeFilter }
    }
    case REGION_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        companySizeFilter: payload.companySizeFilter,
        filterRegionCode: payload.filterRegionCode,
        filterRegionNotification: payload.filterRegionNotification
      }
    }
    case ADD_SELLER_SUCCESS:
    case REMOVE_SELLER_SUCCESS: {
      return { ...state, sellersAdded: payload.sellersAdded }
    }
    case OPEN_MORE_INFO_DIALOG: {
      return { ...state, showMoreInfoDialog: true }
    }
    case CLOSE_MORE_INFO_DIALOG: {
      return { ...state, showMoreInfoDialog: false }
    }
    case SET_ENVIRONMENTAL_VALUE: {
      return { ...state, isEnvironmental: payload.isEnvironmental }
    }
    case SET_SOCIAL_ECONOMIC_VALUE: {
      return { ...state, isSocialEconomic: payload.isSocialEconomic }
    }
    default: {
      return state
    }
  }
}

export default quoteStepTwoReducer
